module.exports = __webpack_public_path__ + "static/poty-6dce529b26be65af49c23a6a5135cfa0.jpg";